<template>

    <v-row class="pa-2 ma-0 mb-4 recipient-email-display">
      <v-col cols="12" class="ma-0 pa-0">
        <v-row>
          <v-col cols="9">
            <v-icon color="blue-grey lighten-1" class="pr-2 pb-1" v-if="isPrimary">mdi-email-seal-outline</v-icon>
            <v-icon color="blue-grey lighten-1" class="pr-2 pb-1" v-else>mdi-email-outline</v-icon>
            {{ emailForDisplay }}
          </v-col>
          <v-col cols="1" v-if="showActions">
            <v-btn plain @click="editEmail">
              <v-icon color="primary" class="pb-1">mdi-pencil</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="1" v-if="showActions">
            <dialog-confirm-button
                buttonStyle="plain"
                :message="`Are you sure you want to remove the email: ${recipientEmail.email}?`"
                icon="mdi-trash-can-outline"
                iconColor="primary"
                v-on:confirmed="deleteEmail" />
          </v-col>
        </v-row>
        <v-row class="ma-0 mt-2 pa-0">
          <v-col cols="12" class="pa-0 mt-2 pl-1">
            <v-icon small color="grey darken-1" class="pb-1 pr-2">mdi-bell</v-icon>
            <span class="notification-opt">{{ enabledNotficationsForDisplay }}</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

</template>

<script>
import DialogConfirmButton from '@/components/app/DialogConfirmButton'

export default {
  name: 'RecipientEmailForm',

  components: {
    DialogConfirmButton
  },

  props: {
    recipientEmail: {
      type: Object,
      required: true
    },
    showActions: {
      type: Boolean,
      default: false
    },
    maskEmails: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      notificationWeights: {
        credit_issued: 1,
        submitted: 2,
        scheduled: 3,
        en_route: 4,
        arrived: 5,
        completed: 6
      }
    }
  },

  computed: {
    uiType () {
      return this.$root.uiType()
    },
    emailForDisplay () {
      if (this.maskEmails) {
        const [localPart, ...domainParts] = this.recipientEmail.email.split('@')
        const domain = '@' + domainParts.join('@')

        if (localPart.length > 2) {
          const mask = '*'.repeat(localPart.length - 2)
          return `${localPart.charAt(0)}${mask}${localPart.charAt(localPart.length - 1)}${domain}`
        } else if (localPart.length === 2) {
          return `**${domain}`
        } else if (localPart.length === 1) {
          return `*${domain}`
        } else {
          return `***${domain}`
        }
      } else {
        return this.recipientEmail.email
      }
    },
    isPrimary () {
      return this.recipientEmail.is_primary
    },
    notifications () {
      return this.recipientEmail.settings || {}
    },
    enabledNotficationsForDisplay () {
      const enabled = []
      for (const opt of Object.keys(this.notifications).sort((a, b) => this.notificationWeights[a] - this.notificationWeights[b])) {
        if (this.notifications[opt] === true) enabled.push(opt)
      }
      return enabled.join(', ')
    }
  },

  methods: {
    editEmail () {
      this.$emit('edit', this.recipientEmail)
    },

    deleteEmail () {
      this.$emit('delete', this.recipientEmail)
    }
  }
}
</script>

<style scoped>
  .recipient-email-display .notification-title {
    color: #6a6a6a !important;
  }

  .recipient-email-display .notification-opt {
    font-size: 0.95rem;
    color: #cfd8dc !important;
  }
</style>
